/**
 * MarketplaceCategories - Category constants and configuration for the Script Marketplace
 */

// Re-export from context for convenience
export { MARKETPLACE_CATEGORIES, REPORT_REASONS, LISTING_STATUS, PRICING_RULES } from '../../contexts/MarketplaceContext';

// Sort options for marketplace listings
export const SORT_OPTIONS = [
  { id: 'popular', name: 'Most Popular', icon: '🔥' },
  { id: 'newest', name: 'Newest', icon: '✨' },
  { id: 'rating', name: 'Highest Rated', icon: '⭐' },
  { id: 'price_low', name: 'Price: Low to High', icon: '💰' },
  { id: 'price_high', name: 'Price: High to Low', icon: '💎' }
];

// Price filter options
export const PRICE_FILTERS = [
  { id: 'all', name: 'All Scripts' },
  { id: 'free', name: 'Free Only' },
  { id: 'paid', name: 'Paid Only' }
];

// Helper function to get category by ID
export const getCategoryById = (categoryId, categories) => {
  return categories.find(c => c.id === categoryId) || { id: 'other', name: 'Other', icon: '📋' };
};

// Helper function to format price
export const formatPrice = (price, isFree) => {
  if (isFree || price === 0) {
    return 'Free';
  }
  return `$${price.toFixed(2)}`;
};

// Helper function to format rating
export const formatRating = (rating, reviewCount) => {
  if (!reviewCount || reviewCount === 0) {
    return 'No reviews yet';
  }
  const displayRating = (typeof rating === 'number') ? rating.toFixed(1) : '0.0';
  return `${displayRating} (${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'})`;
};

// Helper function to get status badge styles
export const getStatusBadgeStyles = (status) => {
  switch (status) {
    case 'active':
      return {
        bg: 'bg-green-100',
        text: 'text-green-800',
        label: 'Active'
      };
    case 'pending_review':
      return {
        bg: 'bg-yellow-100',
        text: 'text-yellow-800',
        label: 'Pending Review'
      };
    case 'draft':
      return {
        bg: 'bg-gray-100',
        text: 'text-gray-800',
        label: 'Draft'
      };
    case 'suspended':
      return {
        bg: 'bg-red-100',
        text: 'text-red-800',
        label: 'Suspended'
      };
    case 'rejected':
      return {
        bg: 'bg-red-100',
        text: 'text-red-800',
        label: 'Rejected'
      };
    case 'deleted':
      return {
        bg: 'bg-gray-200',
        text: 'text-gray-600',
        label: 'Deleted'
      };
    default:
      return {
        bg: 'bg-gray-100',
        text: 'text-gray-800',
        label: status
      };
  }
};
